<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="w-100 h-40">
        <div style="width: 50%; float: left">
          <dv-decoration-3
            style="width: 50%; height: 50px; opacity: 0.2; text-align: center;position: absolute;left:0"
          />
          <div class="line_title" style="padding-top: 2%">当班主管</div>
		  <div class="leader_title" style="padding-top: 3%">{{ supervisor }}</div>
		  </div>
        <div style="width: 50%; float: right">
          <dv-decoration-3
            style="width: 50%; height: 50px; opacity: 0.2; text-align: center;position: absolute;right:0"
          />
          <div class="line_title" style="padding-top: 2%">当班组长</div>
		  <div class="leader_title" style="padding-top: 3%;">{{groupLeader }}</div>
        </div>
      </div>

      <div class="circlelist">
        <ul class="clearfix">
          <li>
            <div class="circle">
              <img v-if="superHeadUrl" :src="superHeadUrl" />
              <img v-if="!superHeadUrl" src="@/assets/img/oee/head.png" />
              </div>
          </li>
          <li>
            <div class="circle">
              <img v-if="headUrl" :src="headUrl" />
              <img v-if="!headUrl" src="@/assets/img/oee/head.png" />
            </div>
          </li>
        </ul>
      </div>
    </dv-border-box-7>


  </div>
</template>

<script>
export default {
  name: "oee-productline-time",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      data: this.bean,
      taskTime: 0,
      headUrl: "",
      superHeadUrl: "",
      supervisor: "",
      groupLeader: "",
      shouldAttend: 0,
    };
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        this.data = val;
        this.formatData();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    formatData() {
      var bean = this.data;
      this.taskTime = bean["taskTime"] || 0;
      this.groupLeader = bean["foreman"] || "";
      this.supervisor = bean["supervisor"] || "";
      this.headUrl = bean["headUrl"];
      this.superHeadUrl =
        bean["superHeadUrl"];
      this.shouldAttend = bean["shouldAttend"] || 0;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>

<style scoped src='../productLine/board.css'>
</style>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/oee/component/oee-productline-time.vue